var _excluded = ["a11yTitle"],
  _excluded2 = ["checked", "indeterminate", "onChecked", "disabled", "noHover", "text", "size"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { jsx as l, jsxs as y } from "react/jsx-runtime";
import { styled as n, css as i, createGlobalStyle as v } from "styled-components";
import { useCallback as z } from "react";
var C = function C(e, t) {
    return typeof e == "number" ? "".concat(e, "px") : e || t;
  },
  L = n.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  min-height: 16px;\n  font-size: 13px;\n"])));
n.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
n.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin: 0;\n"])));
n.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
n(L)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  margin-top: 8px;\n  min-height: 1em;\n  font-size: 16px;\n"])));
n.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
n.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1;\n  letter-spacing: 0.1px;\n  color: ", ";\n"])), function (_ref) {
  var e = _ref.theme;
  return e.colors.red50;
});
i(["font-family:inherit;font-weight:400;font-size:16px;line-height:22px;", "{font-size:14px;}"], function (_ref2) {
  var e = _ref2.theme.down;
  return e("tablet");
});
var d = "0px 1px 8px rgba(0, 0, 0, 0.17)",
  u = "0px 4px 20px rgba(0, 0, 0, 0.07)",
  h = "0px 4px 28px rgba(0, 0, 0, 0.14)";
i(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], d);
i(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], u);
i(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], h);
i(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], d);
i(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], u);
i(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], h);
n.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 1px;\n  height: 0px;\n  padding: 0;\n  overflow: hidden;\n  position: fixed;\n  top: 1px;\n  left: 1px;\n"])));
var F = {
    phoneSm: "320px"
  },
  I = function I(e, t) {
    return t in e.colors;
  },
  S = "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}";
v(["", " img{max-width:100%;height:auto;object-fit:contain;}body{min-width:", ";}body,button,input{font-family:", ";color:", ";}p,a,h1,h2,h3,h4,h5,input,hr,button,section,menu{margin:0;padding:0;}div,section,input,button{box-sizing:border-box;}input{outline:none;}input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,textarea:-webkit-autofill,textarea:-webkit-autofill:hover,textarea:-webkit-autofill:focus,select:-webkit-autofill,select:-webkit-autofill:hover,select:-webkit-autofill:focus{transition:background-color 100s ease-in-out 0s;}button{border:none;}"], S, F.phoneSm, function (_ref3) {
  var e = _ref3.theme;
  return e.fontFamily;
}, function (_ref4) {
  var e = _ref4.theme;
  return e.colors.black10;
});
var T = i(["", ";g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{stroke:none;}*[fill-rule],*[FILL-RULE],*[fill*='#']:not([fill='#FFF']),*[FILL*='#']:not([FILL='#FFF']){fill:inherit;}"], function (_ref5) {
    var _t$colors$r;
    var e = _ref5.color,
      t = _ref5.theme,
      r = _ref5.disabled;
    var o;
    return r ? o = typeof r == "string" ? (_t$colors$r = t.colors[r]) !== null && _t$colors$r !== void 0 ? _t$colors$r : r : t.colors.black80 : e && I(t, e) ? o = t.colors[e] : o = e || t.colors.icon, i(["fill:", ";stroke:", ";"], o, o);
  }),
  b = 24,
  D = function D(e) {
    var t = e.match(/\d+(\.\d+)?/);
    return t ? parseFloat(t[0]) : b;
  },
  j = n.svg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex: 0 0 auto;\n  ", "\n  ", ";\n"])), function (_ref6) {
    var _ref6$size = _ref6.size,
      e = _ref6$size === void 0 ? b : _ref6$size,
      t = _ref6.theme,
      r = _ref6.viewBox;
    var _split = (r || "0 0 ".concat(b, " ").concat(b)).split(" "),
      _split2 = _slicedToArray(_split, 4),
      o = _split2[2],
      p = _split2[3],
      a = +o / +p,
      c = D(t.icons.size[e] || "".concat(e, "px"));
    return o < p ? "\n      width: ".concat(c, "px;\n      height: ").concat(c / a, "px;\n    ") : p < o ? "\n      width: ".concat(c * a, "px;\n      height: ").concat(c, "px;\n    ") : "\n      width: ".concat(c, "px;\n      height: ").concat(c, "px;\n    ");
  }, function (_ref7) {
    var e = _ref7.$hasOwnColorPattern;
    return e ? void 0 : T;
  }),
  f = function f(_ref8) {
    var e = _ref8.a11yTitle,
      t = _objectWithoutProperties(_ref8, _excluded);
    return /* @__PURE__ */l(j, _objectSpread(_objectSpread({}, t), {}, {
      name: e,
      "data-name": "hn-icon"
    }));
  },
  x = function x(e) {
    return /* @__PURE__ */l(f, _objectSpread(_objectSpread({
      viewBox: "0 0 24 24",
      a11yTitle: "Checkbox"
    }, e), {}, {
      children: /* @__PURE__ */l("path", {
        d: "M5.42332 11.3762C5.02556 11.7668 5.02556 12.3999 5.42332 12.7904L8.98813 17.2071C9.38589 17.5976 10.0308 17.5976 10.4285 17.2071L18.5767 8.20711C18.9744 7.81658 18.9744 7.18342 18.5767 6.79289C18.1789 6.40237 17.534 6.40237 17.1363 6.79289L9.70833 15.0858L6.86372 11.3762C6.46596 10.9857 5.82107 10.9857 5.42332 11.3762Z",
        fill: "#FFF"
      })
    }));
  };
x.displayName = "Checkbox";
var g = function g(e) {
  return /* @__PURE__ */l(f, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    a11yTitle: "Dash"
  }, e), {}, {
    children: /* @__PURE__ */l("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.36365 12C4.36365 11.3975 4.85206 10.9091 5.45456 10.9091L18.5455 10.9091C19.148 10.9091 19.6364 11.3975 19.6364 12C19.6364 12.6025 19.148 13.0909 18.5455 13.0909L5.45456 13.0909C4.85206 13.0909 4.36365 12.6025 4.36365 12Z",
      fill: "#0091DF"
    })
  }));
};
g.displayName = "Dash";
var s = n.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  box-sizing: border-box;\n  ", ";\n  justify-content: center;\n  align-items: center;\n  border-radius: 6px;\n"])), function (_ref9) {
    var e = _ref9.$size;
    var t = C(e, "24px");
    return i(["width:", ";max-width:", ";min-width:", ";height:", ";& > svg{width:", ";height:", ";}"], t, t, t, t, t, t);
  }),
  m = n.span(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n  text-align: left;\n"]))),
  B = n.button(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  color: ", ";\n  cursor: pointer;\n  width: fit-content;\n  height: fit-content;\n  align-items: center;\n  background: none;\n  border: none;\n  padding: 0;\n  -webkit-tap-highlight-color: transparent;\n  gap: 8px;\n\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n\n  /* Default state */\n  ", " {\n    background: ", ";\n    border: 2px solid ", ";\n  }\n\n  &:focus-visible ", " {\n    background: ", ";\n    border: 2px solid ", ";\n  }\n\n  ", "\n\n  /* Checked state */\n  &[aria-checked='true'] {\n    ", " {\n      background: ", ";\n    }\n\n    &:focus-visible ", " {\n      background: ", ";\n    }\n\n    ", "\n  }\n\n  /* Disabled state */\n  &:disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n\n    ", " {\n      background: ", ";\n      border: 2px solid ", ";\n    }\n\n    ", " {\n      color: ", ";\n    }\n\n    /* Disabled checked state */\n    &[aria-checked='true'] {\n      ", " {\n        background: ", ";\n      }\n    }\n  }\n"])), function (_ref10) {
    var e = _ref10.theme;
    return e.colors.black10;
  }, s, function (_ref11) {
    var e = _ref11.theme;
    return e.colors.black100;
  }, function (_ref12) {
    var e = _ref12.theme;
    return e.colors.blue60;
  }, s, function (_ref13) {
    var e = _ref13.theme;
    return e.colors.blue95;
  }, function (_ref14) {
    var e = _ref14.theme;
    return e.colors.blue50;
  }, function (_ref15) {
    var e = _ref15.theme,
      t = _ref15.$noHover;
    return !t && i(["@media (hover:hover) and (pointer:fine){&:hover{", "{background:", ";border:2px solid ", ";}}}"], s, e.colors.blue95, e.colors.blue50);
  }, s, function (_ref16) {
    var e = _ref16.theme;
    return e.colors.blue60;
  }, s, function (_ref17) {
    var e = _ref17.theme;
    return e.colors.blue50;
  }, function (_ref18) {
    var e = _ref18.theme,
      t = _ref18.$noHover;
    return !t && i(["@media (hover:hover) and (pointer:fine){&:hover{", "{background:", ";}}}"], s, e.colors.blue50);
  }, s, function (_ref19) {
    var e = _ref19.theme;
    return e.colors.black100;
  }, function (_ref20) {
    var e = _ref20.theme;
    return e.colors.black80;
  }, m, function (_ref21) {
    var e = _ref21.theme;
    return e.colors.black70;
  }, s, function (_ref22) {
    var e = _ref22.theme;
    return e.colors.black80;
  }),
  O = function O(_ref23) {
    var _ref23$checked = _ref23.checked,
      e = _ref23$checked === void 0 ? !1 : _ref23$checked,
      _ref23$indeterminate = _ref23.indeterminate,
      t = _ref23$indeterminate === void 0 ? !1 : _ref23$indeterminate,
      r = _ref23.onChecked,
      _ref23$disabled = _ref23.disabled,
      o = _ref23$disabled === void 0 ? !1 : _ref23$disabled,
      _ref23$noHover = _ref23.noHover,
      p = _ref23$noHover === void 0 ? !1 : _ref23$noHover,
      a = _ref23.text,
      c = _ref23.size,
      k = _objectWithoutProperties(_ref23, _excluded2);
    var w = z(function () {
      var $ = typeof a == "string" ? a : void 0;
      r == null || r(!e, $);
    }, [e, r, a]);
    return /* @__PURE__ */y(B, _objectSpread(_objectSpread({
      role: "checkbox",
      onClick: o ? void 0 : w,
      disabled: o,
      "aria-checked": e,
      "aria-label": "checkbox",
      $noHover: p
    }, k), {}, {
      children: [/* @__PURE__ */l(s, {
        $size: c,
        children: e && /* @__PURE__ */l(R, {
          indeterminate: t
        })
      }), a && /* @__PURE__ */l(m, {
        children: a
      })]
    }));
  },
  R = function R(_ref24) {
    var e = _ref24.indeterminate;
    return e ? /* @__PURE__ */l(g, {
      color: "black100"
    }) : /* @__PURE__ */l(x, {
      color: "black100"
    });
  };
export { O as BlueCheckbox };